var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "home" },
    [
      Object.keys(_vm.alertCertificate).length &&
      _vm.alertCertificate.show_notification
        ? _c(
            "v-col",
            { staticClass: "pa-0 d-none", attrs: { cols: "12" } },
            [
              _c(
                "v-alert",
                {
                  staticClass: "mb-3 inf-alert-error",
                  attrs: {
                    text: "",
                    outlined: "",
                    color: "error",
                    rounded: "",
                    dense: "",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex pa-0 align-center" },
                    [
                      _c("v-icon", { attrs: { color: "error" } }, [
                        _vm._v("mdi-alert"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "ml-5 alert-description-dash" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "body-1 font-weight-bold error--text",
                            },
                            [_vm._v("Certificado digital")]
                          ),
                          _c(
                            "span",
                            { staticClass: "d-block body-2 error--text pb-1" },
                            [
                              _vm.alertCertificate.status === "active"
                                ? [
                                    _vm._v(
                                      " Te queda" +
                                        _vm._s(
                                          _vm.alertCertificate.days_left > 1
                                            ? "n"
                                            : ""
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.alertCertificate.days_left
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.alertCertificate.days_left > 1
                                                ? "días"
                                                : "día"
                                            )
                                        ),
                                      ]
                                    ),
                                    _vm._v(
                                      " restantes, con fecha de vencimiento: "
                                    ),
                                  ]
                                : [_vm._v("Tu certificado digital venció el")],
                              _vm.alertCertificate?.date_end
                                ? _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("date")(
                                              _vm.alertCertificate?.date_end
                                            )
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _vm.$helpers.hasPermission(["add_genericcertificate"])
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                to: { name: "IrsBuiltInSettings" },
                                color: "error",
                              },
                            },
                            [_vm._v("Gestionar certificado")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-col",
        { staticClass: "pa-0 mt-3", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            {
              staticClass: "panel-home",
              style: `margin-bottom:${_vm.setMarginBottom}`,
              attrs: { width: "100%" },
            },
            [
              _c(
                "v-img",
                {
                  attrs: {
                    "min-width": "100%",
                    "min-height": 200,
                    src: require(`@/assets/backgrounds/background-panel-hello.svg`),
                  },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "fill-height ma-0",
                      attrs: { align: "center" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "d-block pl-12 title-panel green-500--text",
                        },
                        [
                          _vm._v(
                            "¡Hola" +
                              _vm._s(
                                _vm.$store.state.auth.userAccount.given_name
                                  ? ` ${_vm.$store.state.auth.userAccount.given_name}`
                                  : ""
                              ) +
                              "! "
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "d-inline-block text-h1 ml-3",
                              staticStyle: {
                                "margin-top": "-20px",
                                position: "absolute",
                              },
                            },
                            [_vm._v("👋🏼")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-0 text-end" },
            [
              _c(
                "v-row",
                {
                  class: [
                    _vm.$vuetify.breakpoint.width > 2500 ? "mt-n3" : "mt-n10",
                    "mb-n2",
                  ],
                  attrs: { align: "center", "no-gutters": "" },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "font-weight-bold subtitle-2 grey-700--text",
                    },
                    [_vm._v("Tus accesos directos")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "grey-900", ripple: false },
                      on: {
                        click: function ($event) {
                          _vm.dialog = true
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-weight-medium body-1" }, [
                        _vm._v("Editar accesos directos"),
                      ]),
                      _c(
                        "v-icon",
                        { staticClass: "ml-2", attrs: { small: "" } },
                        [_vm._v("mdi-open-in-new")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.currentShortcutsList, function (shortcut, i) {
                return _c(
                  "v-row",
                  { key: i },
                  _vm._l(shortcut.children, function (children) {
                    return _c(
                      "v-col",
                      { key: children.title, attrs: { cols: "3" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "px-5 py-7",
                            attrs: {
                              to: {
                                name: children.route,
                                params: _vm.$route.params,
                              },
                              height: "80",
                              "min-width": "190",
                            },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "fill-height ma-0 text-left",
                                attrs: { align: "center" },
                              },
                              [
                                _c("v-img", {
                                  staticStyle: { position: "absolute" },
                                  attrs: {
                                    contain: "",
                                    height: 44,
                                    src: require(`@/assets/shortcuts-icons/avatars/${children.icon}--avatar.svg`),
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-inline-block grey-700--text font-weight-bold ml-14 pl-2",
                                    class:
                                      _vm.$vuetify.breakpoint.width <= 1200
                                        ? "body-2"
                                        : "subtitle-2",
                                    staticStyle: { "line-height": "normal" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        children.title === "SII"
                                          ? _vm.$t("generals.SII")
                                          : children.title
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "1195",
            persistent: "",
            scrollable: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Accesos directos")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: { click: _vm.clear },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pa-0 pb-6" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "inf-alert green-500--text",
                      attrs: {
                        height: 45,
                        dense: "",
                        text: "",
                        outlined: "",
                        tile: "",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center pa-0" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "grey-900", size: "22" } },
                            [_vm._v("mdi-information")]
                          ),
                          _c("div", { staticClass: "ml-4 py-0" }, [
                            _c(
                              "span",
                              { staticClass: "body-1 grey-900--text" },
                              [
                                _vm._v("Selecciona hasta "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("8 accesos directos")]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._l(_vm.shortcutsForModal, function (section) {
                    return _c(
                      "v-col",
                      { key: section.title, staticClass: "px-5 pb-1" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "font-weight-bold subtitle-2 grey-700--text",
                          },
                          [_vm._v(_vm._s(section.title))]
                        ),
                        _c(
                          "v-row",
                          { staticClass: "mt-4", attrs: { "no-gutters": "" } },
                          _vm._l(
                            _vm.getValidChildren(section),
                            function (children, i) {
                              return _c(
                                "v-col",
                                {
                                  key: children.title,
                                  class: {
                                    "pr-3":
                                      i !==
                                      _vm.getValidChildren(section).length - 1,
                                  },
                                  staticStyle: {
                                    "max-width": "20.6% !important",
                                  },
                                  attrs: { cols: "2" },
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "pa-3",
                                      staticStyle: { "border-radius": "5px" },
                                      attrs: { outlined: "", ripple: false },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          ;(children.show = !children.show),
                                            _vm.getShortcuts(children)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 mt-n1",
                                          attrs: {
                                            align: "center",
                                            "no-gutters": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-sheet",
                                            { attrs: { height: "38" } },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "ma-0",
                                                  attrs: {
                                                    align: "center",
                                                    "no-gutters": "",
                                                  },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticStyle: {
                                                      position: "absolute",
                                                    },
                                                    attrs: {
                                                      contain: "",
                                                      height: 44,
                                                      src: require(`@/assets/shortcuts-icons/${
                                                        section.title ===
                                                        "Configuración"
                                                          ? children.icon
                                                          : section.icon
                                                      }--icon.svg`),
                                                    },
                                                  }),
                                                  _c(
                                                    "v-sheet",
                                                    {
                                                      staticClass:
                                                        "ml-7 body-2 align-center d-flex grey-700--text",
                                                      staticStyle: {
                                                        "line-height": "normal",
                                                      },
                                                      attrs: {
                                                        width: "90",
                                                        height: "40",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          children.title ===
                                                            "SII"
                                                            ? _vm.$t(
                                                                "generals.SII"
                                                              )
                                                            : children.title
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-checkbox", {
                                                    staticClass: "mt-n1 mr-2",
                                                    staticStyle: {
                                                      position: "absolute",
                                                      right: "8px",
                                                    },
                                                    attrs: {
                                                      color: "green-500",
                                                      ripple: false,
                                                      dense: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.getShortcuts(
                                                          children
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: children.show,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          children,
                                                          "show",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "children.show",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", ripple: false },
                      on: { click: _vm.clear },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900", ripple: false },
                      on: { click: _vm.saveShortCuts },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }